import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'
import { Stack, Typography } from '@mui/material'

import { form } from '../../formState'
import { useTexts } from './useTexts'

export function BarcodeAttachment() {
  const texts = useTexts()

  const { userType } = useSelector(selectUserConfiguration)
  const rmOnlyAccount = userType === 'rmOnly'

  if (rmOnlyAccount) return null

  return (
    <Stack>
      <form.BulkCheckbox
        name="barcodeAttachmentAllowed"
        testId="barcodeAttachmentAllowed"
        label={texts.addNewBarcodes}
        validateOn="change"
      />
      <Typography
        variant="caption"
        sx={theme => ({ ml: 4, color: theme.vars.palette.text.secondary })}
      >
        {texts.addNewBarcodesHelperText}
      </Typography>
    </Stack>
  )
}
